export var WidgetSize;
(function (WidgetSize) {
    WidgetSize[WidgetSize["MinButton"] = 0] = "MinButton";
    WidgetSize[WidgetSize["Button"] = 1] = "Button";
    WidgetSize[WidgetSize["Frame"] = 2] = "Frame";
    WidgetSize[WidgetSize["FullScreen"] = 3] = "FullScreen";
})(WidgetSize || (WidgetSize = {}));
export var WidgetPlaceholderType;
(function (WidgetPlaceholderType) {
    WidgetPlaceholderType[WidgetPlaceholderType["Docked"] = 0] = "Docked";
    WidgetPlaceholderType[WidgetPlaceholderType["Tiles"] = 1] = "Tiles";
    WidgetPlaceholderType[WidgetPlaceholderType["Floating"] = 2] = "Floating";
    WidgetPlaceholderType[WidgetPlaceholderType["FullScreen"] = 3] = "FullScreen";
})(WidgetPlaceholderType || (WidgetPlaceholderType = {}));
// Component selection utility
export function getComponent(components, size) {
    const component = components[size];
    if (component) {
        return component;
    }
    // Fallback: for Button size, try MinButton
    if (size === WidgetSize.Button && components[WidgetSize.MinButton]) {
        return components[WidgetSize.MinButton];
    }
    return undefined;
}
